<!-- 企业级-平台运营-企业缴纳情况-短信充值 -->
<template>
  <div class="mainArea CSMSRecharge">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <div class="tit">请确认缴费信息</div>
        <div class="cont clearfix">
          <el-form :model="smsform" label-width="80px">
            <el-form-item label="短信费率:">{{smsform.money}}元/条</el-form-item>
            <el-form-item label="剩余条数:">{{smsform.endNum}}</el-form-item>
            <el-form-item label="缴费类型:">{{smsform.platType}}</el-form-item>
            <el-form-item label="充值条数:">
              <div class="numList">
                <el-radio-group v-model="smsform.num">
                  <el-radio border :label="numli.id" v-for="(numli,index) in numList" :key="index">{{numli.name}}</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item label="收款名:">{{smsform.name}}</el-form-item>
            <el-form-item label="账号:">{{smsform.account}}</el-form-item>
          </el-form>
          <div class="item col9">点确认后将跳转到缴费页面</div>
          <div class="item"><el-checkbox v-model="isInvoice">开具发票</el-checkbox></div>
          <div class="item mt30">
            <el-button type="primary" @click="getPlatPay">确认</el-button>
            <el-button @click="backUp">取消</el-button>
          </div>
        </div>
      </div>
      <el-dialog title="支付" :visible.sync="payDio" width="400px" class="payDio" :close-on-click-modal="false" @close="closeEnd">
        <div class="cont_Dio">
          <div class="num">{{smsform.money*smsform.num}}元</div>
          <div class="ewm"><img :src="ewm" alt="支付二维码"></div>
          <div class="tips">请使用微信扫描<br>二维码以完成支付</div>
          <div :class="['tips2',payStatus=='1'?'succTips':'']">{{tips}}</div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { platformApi } from "../../../../static/js/api.js"

  export default {
    name: 'CSMSRecharge',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        numList:[{
          id:1000,
          name:'1000条',
        },{
          id:5000,
          name:'5000条',
        },{
          id:10000,
          name:'10000条',
        },{
          id:50000,
          name:'50000条',
        },{
          id:100000,
          name:'100000条',
        },{
          id:200000,
          name:'200000条',
        }],
        smsform:{
          money:'',
          endNum:'',
          platType:'短信服务费',
          num:1000,
          name:'',
          account:'',
        },
        isInvoice:false,//是否开具发票

        payDio:false,//支付弹窗
        ewm:'',
        order_id:'',
        tips:'请尽快支付，10分钟后二维码失效！',
        payStatus:'0',
      }
    },
    mounted(){
    },
    created: async function () {
      const platInfo = JSON.parse(sessionStorage.getItem('platInfo'))
      if(platInfo){
        this.smsform.money = platInfo.sms_fee
        this.smsform.endNum = platInfo.sms_available_amount
        this.smsform.name = platInfo.company_account_name
        this.smsform.account = platInfo.company_account
      }
    },
    methods: {
      closeEnd(){
        clearInterval(this.setTime)
      },
      //监听缴费状态
      async checkPayStatus(){
        let that = this;
        const dataObj = {
          'order_id': that.order_id,
        }
        const res = await platformApi.checkPayStatus(dataObj)
        if(res.meta.code == 200){
          if(res.data.status == '1'){
            that.payStatus=res.data.status
            that.tips="支付成功"
            clearInterval(that.setTime)
            setTimeout(function(){
              that.backUp()
            },3000)
          }
        }else{
          showToast(res.meta.message)
        }
      },
      //缴费
      async getPlatPay(){
        let that = this;
        if(that.smsform.money == ''||that.smsform.money == 0||that.smsform.endTime==''){
          return false
        }else{
          const dataObj = {
            'type': '2',
            'number': that.smsform.num,
            'bill_flag': that.isInvoice==false? 0 : 1,
          }
          const res = await platformApi.getPlatPay(dataObj)
          if(res.meta.code == 200){
            that.ewm = res.data.code_url
            that.order_id = res.data.order_id
            that.payDio = true
            that.setTime = setInterval(function(){
              that.checkPayStatus()
            },2000)
          }else{
            showToast(res.meta.message)
          }
        }
      },
      //返回上一级
      backUp(){
        this.$router.go(-1);
      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss">
.CSMSRecharge{
  .payDio{
    .el-dialog__body{ padding: 10px 20px 20px;}
    .cont_Dio{
      text-align: center;
      .num{ 
        font-size: 14px;
        color:#333;
      }
      .ewm{
        width: 200px;
        height: 200px;
        margin: 10px auto;
        border: 1px solid #ddd;
        img{ width: 100%;}
      }
      .tips{
        background: #445f85;
        color: #fff;
        padding: 15px 15px 15px 74px;
        position: relative;
        font-size:14px; 
        display: inline-block;
        text-align: left;
        &::before{
          content: "";
          width: 44px;
          height: 44px;
          position: absolute;
          left: 15px;
          top: 50%;
          margin-top: -22px;
          background: url('../../../../static/images/ewm.png') no-repeat;
          background-size: cover;
        }
      }
      .tips2{
        margin-top: 10px;
        color: #999;
        &.succTips{
          color: #67C23A
        }
      }
    }
  }
  .tit{
    font-size:18px;
  }
  .cont{
    margin: 20px 40px;
    font-size: 14px;
    .item{
      margin-bottom: 10px;
      &.col9{ color: #999;}
      &.mt30{ margin-top: 30px;}
    }
  }
  .el-radio.is-bordered{ margin-bottom: 10px;}
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CPlatformOperate/CSMSRecharge.vue